import { SET_RESTAURANT_DATA } from '../actions/restaurantActions';

export default function restaurant(state = {data: 'si funciona'}, action){
    if(action.type === SET_RESTAURANT_DATA){    
        return { data: action.payload }
    }

    return state;
}